<script setup lang="ts">
defineProps<{ active?: boolean }>()
</script>

<!--
  Onglet « Accueil ».

  Règle commune aux quatre icônes de la tab bar (HIG `tab-bars` : « prefer
  filled symbols or icons ») : **trait au repos, PLEIN une fois l'onglet
  actif** — la convention de SF Symbols, et de toutes les tab bars d'iOS.
  Avant, seule `IconUser` se remplissait ; les trois autres ne faisaient
  qu'épaissir leur trait, ce qui ne se voit presque pas sous une bulle colorée.

  La silhouette pleine est une pièce à elle (toit compris) : remplir le
  contour, ouvert en haut, aurait donné une boîte surmontée d'un trait.

  Mais elle reprend **exactement la géométrie du contour**, sinon la maison
  change de taille en même temps que d'état : le toit va d'un débord à l'autre
  (x 3 → 21, apex à 12), et le corps est plus étroit, aligné sur les murs du
  contour (x 5,6 → 18,4). Une première version posait les murs sous les débords
  du toit — la maison sélectionnée était 44 % plus large que l'autre.

  La porte est **creusée** par `fill-rule: evenodd` : un second sous-chemin à
  l'intérieur du premier.
-->
<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- apex → débord droit → mur droit → sol → mur gauche → débord gauche -->
    <path
      v-if="active"
      fill="currentColor"
      fill-rule="evenodd"
      stroke-width="1.1"
      d="M12 3.2 L21 10.6 H18.4 V19.4 a1.4 1.4 0 0 1 -1.4 1.4 H7 a1.4 1.4 0 0 1 -1.4 -1.4 V10.6 H3 Z M9.8 20.8 V15.4 H14.2 V20.8 Z"
    />

    <template v-else>
      <path stroke-width="1.7" d="M3 10.6 12 3.2l9 7.4" />
      <path
        stroke-width="1.7"
        d="M5.6 9.6V19.4a1.4 1.4 0 0 0 1.4 1.4h10a1.4 1.4 0 0 0 1.4-1.4V9.6"
      />
    </template>
  </svg>
</template>
